import { insertartBitacoraCliente } from "../clientes/thunkClientes";
import { insertartBitacoraEmpresa } from "../Empresa/thunkEmpresa";
import {
    cambioEstadoCotizacionApi,
    crearCotizacionApi,
    deleteEliminarCotizacion,
    getCotizacionApi,
    obtener_CotizacionId,
    obtener_CotizacionIdCliente,
    obtener_NumeroConsecutivo,
    obtenerLista_Cotizaciones,
    obtenerSalonesSegunHotel,
} from "./Api_Cotizaciones_Providers";

/**
 * Obtiene la lista de cotizaciones llamando a la API correspondiente.
 *
 * @param {Array} estados - Lista opcional de estados (actualmente no utilizada en la función).
 * @returns {Promise<Array>} Promesa que resuelve con la lista de cotizaciones.
 */
export const obtenerListaCotizaciones = (estados) => {
    return async () => {
        try {
            // Llama a la función para obtener la lista de cotizaciones desde la API.
            const resultado = await obtenerLista_Cotizaciones({ estados });

            // Devuelve los datos de la respuesta (asumiendo que están en la propiedad "0").
            return resultado.data.data;
        } catch (error) {
            console.error("Error al obtener la lista de cotizaciones:", error);
        }
    };
};

export const obtenerCotizacionId = (idConsecutivo) => {
    return async () => {
        try {
            // Llama a la función para obtener la cotización correspondiente al ID proporcionado desde la API.
            const resultado = await obtener_CotizacionId({ idConsecutivo });

            // Devuelve los datos obtenidos de la respuesta (se asume que los datos están en "resultado.data.data").
            return resultado.data.data["0"];
        } catch (error) {
            // Manejo del error al intentar obtener la cotización.
            console.error("Error al obtener la cotización por ID:", error);
        }
    };
};

// Acción para obtener el número consecutivo desde la API
export const obtenerNumeroConsecutivo = () => {
    return async () => {
        try {
            // Realiza la llamada a la función para obtener el número consecutivo desde la API
            const respuesta = await obtener_NumeroConsecutivo();

            // Extrae y devuelve el primer elemento de los datos obtenidos
            return respuesta.data.data[0];
        } catch (error) {
            // Manejo de errores durante la llamada para obtener el número consecutivo
            console.error("Error al obtener el número consecutivo:", error);
            throw new Error("No se pudo obtener el número consecutivo");
        }
    };
};

// Acción para obtener salones desde la API
export const traerSalones = (idHotel) => {
    return async () => {
        try {
            // Realiza la llamada a la función para obtener salones del hotel desde la API
            const respuesta = await obtenerSalonesSegunHotel(idHotel);

            // Retorna la lista de salones obtenida
            return respuesta.data.data;
        } catch (error) {
            // Manejo de errores al intentar obtener los salones
            console.error("Error al obtener los salones:", error);
            throw new Error("No se pudo obtener los salones");
        }
    };
};

// Acción para crear una cotización utilizando datos del formulario y fechas
export const crearCotizacion = (formulario, fechas, mostrarCalendario) => {
    // Retorna una función asincrónica que realiza la creación de la cotización
    return async (dispatch, getState) => {
        const { id_admin } = getState().auth;
        try {
            // Combina los datos del formulario y las fechas en un solo objeto
            const datosCompletos = {
                formulario, // Datos del formulario para la cotización
                fechas, // Fechas relevantes para la cotización
                id_admin,
                mostrarCalendario,
            };
            // Llama a la función para crear la cotización en la API con los datos preparados
            const respuesta = await crearCotizacionApi({ datosCompletos });
            

            if (formulario.datosCliente.id_cliente > 0) {
                await dispatch(
                    insertartBitacoraCliente({
                        bitacora_cliente: formulario.datosCliente.id_cliente,
                        bitacora_nombreCliente: "Cotizacion creada",
                        bitacora_detalle: `Se le ha generado una Cotizacion para este cliente Cotizacion #${formulario.consecutivo} , Nombre Cotizacion: ${formulario.nombreEvento}`,
                    }),
                );
            }
            if (formulario.empresaSeleccionada > 0) {
                const nota = `Se le ha generado una Cotizacion para esta empresa Cotizacion #${formulario.consecutivo} , Nombre Cotizacion: ${formulario.nombreEvento}`;
                const idEmpresa = formulario.empresaSeleccionada;
                await dispatch(insertartBitacoraEmpresa(nota, idEmpresa));
            }

            const { data } = respuesta;

            return data;


            // Opcional: Si se requiere retornar información específica, ajustar aquí
            // return respuesta.data.data;
        } catch (error) {
            // Maneja y registra errores ocurridos durante la solicitud
            console.error("Error al crear la cotización:", error.message || error);
            throw new Error("No se pudo crear la cotización. Verifique los datos proporcionados.");
        }
    };
};


// Acción para obtener una cotización desde la API
export const getCotizacion = (id) => {


    return async () => {
        try {
            // Llama a la función que realiza la solicitud a la API para obtener la cotización
            const respuesta = await getCotizacionApi({ id });

            // Retorna los datos de la cotización obtenidos de la respuesta
            return respuesta.data;
        } catch (error) {
            // Maneja los errores ocurridos durante la solicitud
            console.error("Error al obtener la cotización:", error);
            throw new Error("No se pudo obtener la cotización");
        }
    };
};


// Acción para eliminar una cotización mediante la API
export const eliminarCotizacion = (id) => {
    return async () => {
        try {
            // Realiza la solicitud a la API para eliminar la cotización con el id proporcionado
            const respuesta = await deleteEliminarCotizacion({ id });

            // Retorna la respuesta de la API, que contiene los datos relacionados con la eliminación de la cotización
            return respuesta.data;
        } catch (error) {
            // Captura y maneja los errores que puedan ocurrir durante la solicitud a la API
            console.error("Error al eliminar la cotización:", error);
            throw new Error("No se pudo eliminar la cotización");
        }
    };
};


export const editarCotizacion = (formulario, fechas, mostrarCalendario, id_admin, ids) => {

    /**
     * Función que retorna un thunk asincrónico para editar una cotización.
     * Este proceso incluye eliminar la cotización previa y crear una nueva
     * con los datos proporcionados.
     */
    return async (dispatch) => {
        try {
            /**
             * Combina los datos del formulario y las fechas en un objeto único,
             * incluyendo información adicional como el identificador del administrador
             * y si se debe mostrar el calendario.
             */
            const datosCompletos = {
                formulario, // Datos del formulario necesarios para la nueva cotización
                fechas, // Fechas relevantes asociadas a la cotización
                id_admin, // Identificador del administrador que realiza el cambio
                mostrarCalendario, // Indicador de visibilidad del calendario
            };
            const id =formulario.consecutivo;  
            // Elimina la cotización existente utilizando los identificadores proporcionados
            await dispatch(eliminarCotizacion(id));

            // Crea una nueva cotización en la API con los datos combinados
            const respuesta2 = await crearCotizacionApi({ datosCompletos });

            // Extrae la respuesta de la API, asumiendo que contiene los datos relevantes
            const { data } = respuesta2;

            // Retorna los datos obtenidos de la creación de la cotización
            return data;
        } catch (error) {
            // Maneja errores durante el proceso y proporciona un mensaje claro
            console.error("Error al editar la cotización:", error.message || error);
            throw new Error("No se pudo editar la cotización. Verifique los datos proporcionados.");
        }
    };
};


export const cambioEstadoCotizacion = (ids, estadosRelacionados, value, token) => {
    /**
     * Retorna un thunk asincrónico para cambiar el estado de una o varias cotizaciones.
     * Este proceso implica actualizar las cotizaciones especificadas a través de una API.
     *
     * @param {Array} ids - Identificadores de las cotizaciones a modificar.
     * @param {string} estado - Nuevo estado que se asignará a las cotizaciones.
     * @param {string} labael - Etiqueta asociada al cambio de estado (posible error en el nombre, debería ser "label").
     * @param {string} color - Color relacionado con el nuevo estado de las cotizaciones.
     */
    return async (dispatch, getState) => {
        try {
            // Envía la solicitud a la API para cambiar el estado de las cotizaciones especificadas
            const respuesta2 = await cambioEstadoCotizacionApi({ ids, estadosRelacionados, value, token });

            // Extrae los datos relevantes de la respuesta de la API
            const { data } = respuesta2;

            // Retorna los datos obtenidos, que indican el resultado del cambio de estado
            return data;
        } catch (error) {
            // Captura y maneja errores, proporcionando un mensaje claro en caso de fallo
            console.error("Error al cambiar el estado de la cotización:", error.message || error);
            throw new Error("No se pudo cambiar el estado de la cotización. Verifique los datos proporcionados.");
        }
    };
};



export const extarerCotizacionesCliente = (dato) => {
    return async () => {
        try {
            // Llama a la función para obtener la cotización correspondiente al ID proporcionado desde la API.
            const resultado = await obtener_CotizacionIdCliente({ dato });

            console.log(resultado)

            // Devuelve los datos obtenidos de la respuesta (se asume que los datos están en "resultado.data.data").
            return resultado.data.data;
        } catch (error) {
            // Manejo del error al intentar obtener la cotización.
            console.error("Error al obtener la cotización por ID:", error);
        }
    };
};
